import { styled } from "twin.macro";

export const ProjectStyled = styled.div`
	overflow: visible;
`;
